import { computed, makeObservable } from 'mobx'

import buildUrl from 'modules/core/lib/buildUrl'
import { Model } from 'modules/core/lib/mobx-rest'

type PictureStatus =
  | 'processing'
  | 'employee-picture-uploaded'
  | 'invalid-image'
  | 'collection-for-company-not-created'
  | 'service-unavailable'

interface IEmployeePicture {
  id: number
  status: PictureStatus
  employee_id: number
  filename: string
  content_type: string
  created_at: number
}

class EmployeePicture extends Model<IEmployeePicture> {
  constructor(attr: IEmployeePicture) {
    super(attr)
    makeObservable(this, {
      isProcessing: computed,
      isInvalid: computed,
    })
  }

  get isProcessing(): boolean {
    return this.attributes.status === 'processing'
  }

  get isInvalid(): boolean {
    return ['invalid-image', 'collection-for-company-not-created', 'service-unavailable'].includes(
      this.attributes.status
    )
  }

  get downloadUrl(): string {
    return buildUrl(`/${this.url()}/download`)
  }

  static urlRoot() {
    return '/face_recognition/employee_pictures'
  }
}

export default EmployeePicture
